import { Grid, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'
import { WrapperProps } from '../../../components'

const SectionLineHeader = styled(Typography)(({ theme }) => {
  const { colors, fontSizes } = theme.variables
  return {
    color: colors.sectionLineHeader,
    fontSize: fontSizes.sectionLineHeader
  }
})

interface MainContentSectionLineProps extends WrapperProps {
  lineHeader?: string
}

export const MainContentSectionLine = ({
  children,
  lineHeader
}: MainContentSectionLineProps) => {
  return (
    <Grid container pb={lineHeader ? 2 : 0}>
      {lineHeader && (
        <Grid item md={12} xs={12}>
          <SectionLineHeader>{lineHeader}</SectionLineHeader>
        </Grid>
      )}
      <Grid item md={12} xs={12}>
        {children}
      </Grid>
    </Grid>
  )
}
